import * as React from 'react';
import { Modal } from 'antd';
import { BaseModalContentProps } from './BaseModalContent';

export interface BaseModalProps extends BaseModalContentProps {}

export const BaseModal = (props: BaseModalProps) => {
  const { children, title, onOk, onCancel, okText, cancelText, icon, ...rest } = props;

  return (
    <Modal
      width={480}
      destroyOnClose
      modalRender={() => children}
      onCancel={onCancel}
      maskClosable={false}
      {...rest}
    />
  );
};

export function baseRender<T extends BaseModalContentProps>(renderData: {
  modal;
  renderComponent?: (contentProps) => React.ReactNode;
  props?: T;
}) {
  const { modal, renderComponent, props } = renderData;

  const {
    centered = true,
    title,
    onOk,
    onCancel,
    okText,
    cancelText,
    icon,
    okButtonDisabled,
    ...rest
  } = props;

  modal.update({
    ...rest,
    modalRender: () => renderComponent(props),
    centered,
  });
}
